export default [
    {
        icon: 'fa fa-trash',
        action: 'delete',
        title: 'Удалить',
        color: 'red',
    },
];
